import { notification } from "antd";

const showSuccessNotification = (description?: string) => {
	const defaultMessage = "Başarılı";
	const defaultDescription = "İşleminiz başarılı şekilde gerçekleşti.";

	notification.success({
		message: defaultMessage,
		description: description || defaultDescription,
		placement: "bottomRight",
	});
};

const showErrorNotification = (description?: string) => {
	const defaultMessage = "Hata";
	const defaultDescription = "İşleminiz sırasında bir hata oluştu.";

	notification.error({
		message: defaultMessage,
		description: description || defaultDescription,
		placement: "bottomRight",
	});
};

const showWarningNotification = (description?: string) => {
	const defaultMessage = "Uyarı";
	const defaultDescription = "Uyarı mesajı";

	notification.warning({
		message: defaultMessage,
		description: description || defaultDescription,
		placement: "bottomRight",
	});
};

const showInfoNotification = (description?: string) => {
	const defaultMessage = "Bilgi";
	const defaultDescription = "Bilgilendirme mesajı";

	notification.info({
		message: defaultMessage,
		description: description || defaultDescription,
		placement: "bottomRight",
	});
};

export { showSuccessNotification, showErrorNotification, showWarningNotification, showInfoNotification };
